import { SummitFormattedText } from '@summit/models';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Employee } from '../../employee/employee';
import { EboRoles, EboRolesMapping } from '../../shared/policies/ebo-roles.enum';
import { Division } from '../division';

export class DivisionPolicyStep extends EboNameObject {
  policyId: string;
  path: number;
  cycle: number;

  //Who Can Approve
  employeeID: string;
  employee: Employee;
  role: EboRoles;
  divisionId: string;
  division: Division;

  constructor(jsonData?: Partial<DivisionPolicyStep>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.employee) {
        this.employee = new Employee(jsonData.employee);
      }
      if (jsonData.division) {
        this.division = new Division(jsonData.division);
      }
    }
    this.path ??= 1;
    this.cycle ??= 1;
  }

  get approver(): string {
    if (this.employee) return this.employee?.name;
    if (this.division) return `${this.division?.name}: ${EboRolesMapping[this.role]}`;
    return `Any ${EboRolesMapping[this.role]}`;
  }

  toSummary(): SummitFormattedText {
    const summary = new SummitFormattedText();
    summary.AddKeyValues(`Path: ${this.path}, Step: ${this.cycle} ${this.name}`, this.approver);
    return summary;
  }
}
